module.exports = __webpack_public_path__ + "static/media/vi.faa818be.svg";